import React, { FC, useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTheme } from 'styled-components';
import { useTranslate } from '@/translations';
import { useStorageGraph } from '@/api/Storage';
import { Spin } from 'antd';

export const StorageChart: FC = () => {
  const { t } = useTranslate();
  const { primaryChartColor, secondaryChartColor } = useTheme();
  const { data, isFetching: isLoading } = useStorageGraph();
  const graphData = data?.entities;

  const options: echarts.EChartsOption = useMemo(
    () => ({
      title: { text: t('storageUtilisation') },
      grid: {
        top: 80,
        left: 50,
        right: 30,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
      },
      legend: {
        bottom: 10,
      },
      xAxis: [
        { type: 'category', data: graphData?.map((o) => o.locationDesc) },
      ],
      yAxis: [{ type: 'value' }],
      series: [
        {
          name: t('freeSlots'),
          type: 'bar',
          stack: 'total',
          data: graphData?.map((o) => o.freeSlots),
          label: { show: true, color: '#fff' },
          itemStyle: { color: primaryChartColor },
        },
        {
          name: t('utilisation'),
          type: 'bar',
          stack: 'total',
          data: graphData?.map((o) => o.utilisation),
          label: { show: true, color: '#fff' },
          itemStyle: { color: secondaryChartColor },
        },
      ],
    }),
    [graphData, primaryChartColor, secondaryChartColor, t],
  );

  return (
    <Spin spinning={isLoading}>
      <ReactECharts option={options} style={{ height: 500 }} />
    </Spin>
  );
};
